var map = {
	"./1.png": "775a",
	"./10.png": "4abd",
	"./2.jpg": "cedd",
	"./3.png": "1f66",
	"./4.png": "5fa5",
	"./5.png": "c037",
	"./6.png": "338d",
	"./7.png": "0f01",
	"./8.png": "eadf",
	"./9.png": "6846",
	"./Background.jpg": "2706",
	"./Hules_Colores.png": "6ed3",
	"./IconoAdherible.png": "6317",
	"./IconoFloorGraphic.png": "f38c",
	"./IconoIman.png": "e58a",
	"./IconoLonas.png": "98f6",
	"./IconoMicrooperforado.png": "8018",
	"./IconoPapelBond.png": "6767",
	"./IconoPlayeras.png": "7a1e",
	"./IconoTazas.png": "38a1",
	"./IconoTelas.png": "5919",
	"./IconoVinil.png": "1762",
	"./IconoVinilAdherible.png": "650b",
	"./IconoVinilTextil.png": "271b",
	"./Logo1.png": "6288",
	"./Producto.png": "b154",
	"./makinota.jpg": "5572"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";